var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertyDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.60645 16.1534C4.60645 14.9292 5.16702 13.7725 6.12787 13.0139L15.0215 5.9926C16.4747 4.84531 18.5254 4.84531 19.9787 5.9926L28.8723 13.0139C29.8331 13.7725 30.3937 14.9292 30.3937 16.1534V27.1803C30.3937 29.3895 28.6029 31.1803 26.3937 31.1803H22.5718C22.0195 31.1803 21.5718 30.7326 21.5718 30.1803V25.037C21.5718 23.9324 20.6763 23.037 19.5718 23.037H15.4284C14.3238 23.037 13.4284 23.9324 13.4284 25.037V30.1803C13.4284 30.7326 12.9807 31.1803 12.4284 31.1803H8.60645C6.39731 31.1803 4.60645 29.3895 4.60645 27.1803L4.60645 16.1534Z",
    fill: "url(#paint0_linear_5443_5329)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60645 16.1534C4.60645 14.9292 5.16702 13.7725 6.12787 13.0139L15.0215 5.9926C16.4747 4.84531 18.5254 4.84531 19.9787 5.9926L28.8723 13.0139C29.8331 13.7725 30.3937 14.9292 30.3937 16.1534V27.1803C30.3937 29.3895 28.6029 31.1803 26.3937 31.1803H22.5718C22.0195 31.1803 21.5718 30.7326 21.5718 30.1803V25.037C21.5718 23.9324 20.6763 23.037 19.5718 23.037H15.4284C14.3238 23.037 13.4284 23.9324 13.4284 25.037V30.1803C13.4284 30.7326 12.9807 31.1803 12.4284 31.1803H8.60645C6.39731 31.1803 4.60645 29.3895 4.60645 27.1803L4.60645 16.1534Z",
    stroke: "url(#paint1_linear_5443_5329)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 22.8672V5.69324C18.6517 5.69324 19.8035 6.07036 20.7589 6.82459L28.2236 12.7178C29.4869 13.7152 30.224 15.2361 30.224 16.8457V25.7513C30.224 28.6559 27.8693 31.0105 24.9647 31.0105H22.9289C22.273 31.0105 21.7413 30.4788 21.7413 29.8229V25.7513C21.7413 25.3798 21.6711 25.0247 21.5432 24.6985C21.4011 23.8653 20.7437 23.2077 19.9105 23.0655C19.5842 22.9375 19.2289 22.8672 18.8572 22.8672H17.5Z",
    fill: "#0088CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_5443_5329",
    x: 0.436768,
    y: 0.962463,
    width: 34.1267,
    height: 34.3875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_5329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_5329",
    result: "effect2_dropShadow_5443_5329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_5329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_5329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5443_5329",
    x: 15.5,
    y: 3.69324,
    width: 16.7239,
    height: 29.3173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5443_5329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5443_5329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5443_5329",
    x1: -3.77442,
    y1: -6.82198,
    x2: 46.0859,
    y2: 35.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5443_5329",
    x1: 5.25113,
    y1: 8.1075,
    x2: 28.7869,
    y2: 27.2723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyDark);
export default __webpack_public_path__ + "static/media/property-dark.1cb389cd49ece5cf80f42a1dea3da470.svg";
export { ForwardRef as ReactComponent };